<template>
  <v-table
    ref="table"
    :url="url"
    :filter="InsOutsFilter"
    @table-fetched="updateTotal"
    :fetchAfterCreate="true"
    :row-classes="{
      'table-warning': model => {
        return Boolean(model.disabled_at);
      },
      'table-danger': model => {
        return Boolean(model.deleted_at);
      }
    }"
    :attributes="[
      {
        name: 'Moderator',
        type: 'UserNoEmailCell',
        attribute: 'user'
      },
      {
        attribute: 'total_performance',
        name: 'Verdiente Einheiten'
      },
      {
        attribute: 'ins',
        name: 'INs'
      },
      {
        attribute: 'outs',
        name: 'OUTs'
      }
    ]"
  >
    <div slot="filter">
      <table-filter
        :filterComponents="[
          {
            id: 0,
            type: 'SelectFilter',
            label: 'Agentur',
            options: agencyOptions,
            attributes: 'agency_id'
          },
          {
            id: 1,
            type: 'InOutPerformanceFilter',
            label: 'Zeitraum'
          }
        ]"
        v-model="InsOutsFilter"
        @apply-filters="$bus.$emit('refresh-table')"
      ></table-filter>
    </div>
    <tr slot="top" v-if="total">
      <td v-for="(attribute, index) in summaryFields" :key="'row-' + index">
        <strong>
          {{ index === 0 ? "Gesamt:" : total[attribute] }}
        </strong>
      </td>
    </tr>
  </v-table>
</template>

<script lang="babel">
import moment from "moment";
export default {
  props: {
    url: {
      type: String,
      required: false,
      default: '/api/v1/moderator/'
    }
  },
  data(){
    return {
      totalInsOuts: "0 / 0",
      settings: null,
      summaryFields: ['','total_performance', 'ins','outs'],
      total: {ins: 0, outs: 0, total_performance: 0},
      InsOutsFilter: [
        {
          name: "in_out_performance",
          id: 1,
          attributes: [
            {
              value: moment()
                .startOf("month")
                .format("YYYY-MM-DD")
            },
            {
              value: moment()
                .endOf("month")
                .format("YYYY-MM-DD")
            }
          ]
        },
      ]
    }
  },
  computed: {
    agencyOptions () {
      let agencyOptions = [{ value: null, label: "Alle" }];
      let agencies = this.$store.getters["agency/agencys"];
      agencies.forEach(agency => {
        agencyOptions.push({value: agency.id, label: agency.name});
      });
      return agencyOptions;
    },
  },
  created () {
    this.$store.dispatch("agency/read");
  },
  methods: {
    updateTotal() {
      let agency_filter = this.InsOutsFilter.find(({id}) => id === 0);
      let in_out_filter = this.InsOutsFilter.find(({id}) => id === 1);
      let agency_id = agency_filter ? agency_filter.attributes.agency_id: null;
      this.$http.get('/api/v1/moderator/sum/',
        {params: {
                  from: in_out_filter.attributes[0].value,
                  to: in_out_filter.attributes[1].value,
                  agency_id: agency_id
                 }
                  }).then(({data}) => {
          this.total = data;
      });
    }
  }

};
</script>
